export default {
  namespaced: true,
  state: {
    inventoryBookData: {
      stockIdList: [],
      differentStock: 1,
      containAllot: 0,
      iscontain: true,
      productName: [],
      productId: ''
    }
  },
  mutations: {
    addInventoryBookData (state, val) {
      state.inventoryBookData = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/searchData.js